export const TRANSACTION = {
    RECIVE: "TRANSACTION.RECIVE",
    RECIVE_ALL: "TRANSACTION.RECIVE_ALL",
    FLASH_ERROR: "TRANSACTION.FLASH_ERROR",
    CLEAR_FLASH_ERROR: "TRANSACTION.CLEAR_FLASH_ERROR",
    RECIVE_2FA: "TRANSACTION.RECIVE_2FA",
    CLEAR_2FA: "TRANSACTION.CLEAR_2FA",
    FEE: "TRANSACTION.FEE",
};
